import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import ModalCustom from "./modal-template-default";
import Button from "../Button";
import { toast } from "react-toastify";
import Slct from "../Slct";
import Required from "../Required";

export default function ModalChangeAttendant(props) {
  const { show, closeModal, attendance_id, user_id, category_id, resource_id } = props;
  const { me, config } = useWrapper();

  const [users, setusers] = useState();
  const [categories, setcategories] = useState();

  const [isLoadingSave, setisLoadingSave] = useState();
  const [isLoadingEssential, setisLoadingEssential] = useState();
  const [isLoadingRequest, setisLoadingRequest] = useState();
  const [isWaitingResponse, setisWaitingResponse] = useState(false);

  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingEssential || isLoadingRequest);
  }, [isLoadingEssential, isLoadingEssential, isLoadingRequest]);

  const [attendance, setattendance] = useState();
  const resetAttendance = () => {
    setattendance({
      user_id,
      category_id,
      resource_id,
    });
  };
  const onHide = () => {
    closeModal();
    resetAttendance();
  };

  useEffect(() => {
    resetAttendance();
  }, [show]);

  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);
        const { data: _categories } = await api.get(`categories?paginate=false`, config);
        setcategories(
          _categories.map(__category => ({
            value: __category?.id,
            label: __category?.name,
            resources: __category?.resource?.map(__resource => ({
              value: __resource?.id,
              label: __resource?.name,
            })),
          })),
        );
        const { data: _users } = await api.get("users?active=1&joins=null&paginate=false", config);
        setusers(
          _users?.map(__user => ({
            label: __user?.username,
            value: __user?.id,
          })),
        );
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar os dados.");
      } finally {
        setisLoadingEssential(false);
      }
    })();
  }, []);

  async function changeAttendance() {
    if (!attendance) return;
    try {
      setisLoadingSave(true);
      await api.put(
        `attendance/${attendance_id}`,
        {
          resource_id: attendance?.resource_id,
          category_id: attendance?.category_id,
          user_id: attendance?.user_id,
        },
        config,
      );
      toast.success("Atendimento atualizado com sucesso!");
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar atualizar o atendimento.");
    } finally {
      setisLoadingSave(false);
      onHide();
    }
  }

  return (
    <ModalCustom size="lg" show={show} onHide={onHide} disableClose={!!isLoadingSave}>
      <ModalCustom.Header>
        <h2 className="page-title">Modificar Atendimento</h2>
      </ModalCustom.Header>
      <ModalCustom.Body>
        <Container>
          <Row>
            <Col xs={4}>
              <span>
                Atendente <Required />
              </span>
              <Slct
                isDisabled={!!isWaitingResponse}
                required={true}
                options={users || []}
                value={attendance?.user_id}
                onChange={__ev => {
                  setattendance({
                    ...attendance,
                    user_id: __ev.value,
                  });
                }}
                placeholder="..."
              />
            </Col>
            <Col xs={4}>
              <span>
                Categoria <Required />
              </span>
              <Slct
                isDisabled={!!isWaitingResponse}
                required={true}
                options={categories || []}
                value={attendance?.category_id}
                onChange={__ev => {
                  setattendance({
                    ...attendance,
                    category_id: __ev.value,
                    resource_id: null,
                  });
                }}
                placeholder="..."
              />
            </Col>
            <Col xs={4}>
              <span>
                Recurso <Required />
              </span>
              <Slct
                isDisabled={!!isWaitingResponse}
                required={true}
                options={categories?.find(__category => __category?.value === attendance?.category_id)?.resources || []}
                value={attendance?.resource_id}
                onChange={__ev => {
                  setattendance({
                    ...attendance,
                    resource_id: __ev.value,
                  });
                }}
                placeholder="..."
              />
            </Col>
          </Row>
        </Container>
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <Button disabled={!attendance} loading={!!isLoadingSave} color={"primary"} onClick={changeAttendance}>
          Modificar Atendimento
        </Button>
      </ModalCustom.Footer>
    </ModalCustom>
  );
}
